module.exports = __webpack_public_path__ + "static/media/fr.38fd906a.png";